/**
 * Navigation utilities for QR overlay auto-refresh
 */

const STALE_THRESHOLD_MS = 5 * 60 * 1000; // 5 minutes

/**
 * Open QR overlay with stale check
 *
 * If the QR overlay was last loaded more than 5 minutes ago (or never),
 * do a full page reload to get latest app updates and fresh connection.
 * Otherwise, use instant overlay toggle via showQR().
 *
 * @param {function} showQR - showQR function from NavigationContext
 */
export const navigateToQR = (showQR) => {
  const lastLoad = sessionStorage.getItem('qrLastFullLoad');
  const isStale = !lastLoad || Date.now() - parseInt(lastLoad, 10) > STALE_THRESHOLD_MS;

  if (isStale) {
    console.log('[NAV] QR overlay stale, doing full reload');
    sessionStorage.setItem('nav_qr_open', 'true');
    window.location.reload();
  } else {
    console.log('[NAV] QR overlay fresh, using showQR()');
    showQR();
  }
};
